export default class A11yHelper {
  public static isFocusWithinCurrentGroup(event: FocusEvent | null): boolean {
    /*
     * event / event.relatedTarget === null when the whole window loses focus / the user clicks somewhere on the page
     * when this happens return false to close whatever is currently open
     */
    if(!event || !event.relatedTarget) {
      return false;
    }

    // relatedTarget & target are typed as EventTarget which only has event listener functions - they are type HTMLElement as well though so casting to one for TS to be happy
    const htmlRelatedTarget = event.relatedTarget as HTMLElement;
    const htmlRelatedTargetAttributes = htmlRelatedTarget.getAttributeNames();
    const htmlTarget = event.target as HTMLElement;
    const htmlTargetAttributes = htmlTarget.getAttributeNames();

    /*
     * when tabbing into the header dropdown we switch the data-v- scope and therefore would close
     * the dropdown immediately after opening it
     * to prevent this we can set a 'data-keyboard-navigation-keep-open' attribute and
     * return true if we encounter this attribute
     */
    if(htmlRelatedTargetAttributes.includes(`data-keyboard-navigation-keep-open`)) {
      return true;
    }

    /*
     * when tabbing through the header it happens that we stay within the same data-v- attributes
     * although we moved the cursor from one top level element to another
     * realistically we should only ever encounter this when tabbing backwards through the navigation elements (e.g. Corporate to So New)
     * since if we tab forwards and open a dropdown we would tab into the dropdown and tabbing out of
     * it is already handled elsewhere
     * To provide a plug in way to force close the dropdown both elements (relatedTarget and target)
     * can be equipped with the 'data-keyboard-navigation-force-close' attribute
     *
     * closing the dropdown when tabbing out of the group is already handled
     */
    if(htmlRelatedTargetAttributes.includes(`data-keyboard-navigation-force-close`) && htmlTargetAttributes.includes(`data-keyboard-navigation-force-close`)) {
      return false;
    }
    const relatedTargetHtmlElementDataVAttribute = htmlRelatedTarget.getAttributeNames().filter(attributeName => attributeName.includes(`data-v-`))[0];
    const targetHtmlElementDataVAttribute = htmlTarget.getAttributeNames().filter(attributeName => attributeName.includes(`data-v-`))[0];
    return relatedTargetHtmlElementDataVAttribute === targetHtmlElementDataVAttribute;
  }
}
